import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { PrimaryTab } from '@devfolioco/genesis';
import { Analytics } from '@devfolioco/helpers';

import { history } from 'helpers/history';
import { ANALYTICS_TRACKING_EVENTS } from '@constants';

const fireAnalyticsOnTabChange = tab => {
  Analytics.trackEvent(ANALYTICS_TRACKING_EVENTS.PRIMARY_TAB_CHANGE, {
    tab,
  });
};

class Header extends React.PureComponent {
  getInitialActive = url => {
    if (url.includes('profile')) {
      return 1;
    }

    if (url.includes('badges')) {
      return 3;
    }

    if (url.includes('projects')) {
      return 4;
    }

    return 2;
  };

  handleChange = key => {
    switch (key) {
      case 1:
        history.push('/profile');
        fireAnalyticsOnTabChange('profile');
        break;
      case 2:
        history.push('/hackathons/applied');
        fireAnalyticsOnTabChange('my hackathons');
        break;
      case 3:
        history.push('/badges');
        fireAnalyticsOnTabChange('badges');
        break;
      case 4:
        history.push('/projects');
        fireAnalyticsOnTabChange('projects');
        break;
      default:
        history.push('/profile');
    }
  };

  render() {
    const {
      match: { url },
      userStats,
      ...other
    } = this.props;

    const headerItems = [
      {
        id: 1,
        heading: 'profile',
        // subHeading: `${profileCompletionMetric}%`,
        // alert: profileCompletionMetric < 100,
      },
      {
        id: 2,
        heading: 'hackathons',
        subHeading: userStats?.hackathons || 0,
      },
      {
        id: 3,
        icon: 'zap',
        heading: 'Badges',
        subHeading: userStats?.badges || 0,
      },
      {
        id: 4,
        heading: 'Projects',
        subHeading: userStats?.projects || 0, // TODO update this
      },
    ];

    return (
      <PrimaryTab
        onChange={this.handleChange}
        initialActive={this.getInitialActive(url)}
        items={headerItems}
        {...other}
      />
    );
  }
}

const mapStateToProps = ({ user }) => ({
  userStats: user.userStats,
});

export default withRouter(connect(mapStateToProps)(Header));
